import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BixiI18nService } from '@bixi/core/i18n';
import { Subscription } from 'rxjs';
import { IFilterCol } from '../filter.type';

@Component({
  selector: 'bixi-filter-keys',
  exportAs: 'bixiFilterKeys',
  templateUrl: './filter-keys.component.html',
  host: {
    '[class.bixi-filter-keys]': 'true',
    '[class.bixi-filter-header-right-element]': 'true'
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiFilterKeysComponent implements OnInit, OnDestroy {
  allChecked = false;
  popoverVisible = false;
  _cols: IFilterCol[] = [];
  title = '全部';
  i18nSubscription = new Subscription();

  @Input()
  get cols() {
    return this._cols;
  }
  set cols(value: IFilterCol[]) {
    this._cols = value;
    this.updateChecked();
  }
  @Output() filterColsChange: EventEmitter<IFilterCol[]> = new EventEmitter<IFilterCol[]>();

  constructor(
    private i18n: BixiI18nService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.i18nSubscription = this.i18n.localeChange.subscribe(() => {
      this.title = this.i18n.getLocaleData('filter.all');
      this.cdr.markForCheck();
    });
  }

  drop(event: CdkDragDrop<IFilterCol[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.filterColsChange.emit(event.container.data);
  }

  updateChecked() {
    this.allChecked = this.cols.every(col => col.visible !== false || col.disabled);
  }

  onSelectAll(checked: boolean) {
    this._cols = this.cols.map((col) => {
      if (col.disabled) {
        return col;
      }
      col.visible = checked;
      return col;
    });
    this.filterColsChange.emit(this.cols);
  }

  onColClick(checked: boolean, item: IFilterCol) {
    this._cols = this.cols.map((col) => {
      if (item.name === col.name && item.keyAlias === col.keyAlias) col.visible = checked;
      return col;
    });
    this.updateChecked();
    this.filterColsChange.emit(this.cols);
  }

  ngOnDestroy() {
    this.i18nSubscription.unsubscribe();
  }
}
